const nrConfigurations = {
	init: {
		distributed_tracing: { enabled: true },
		privacy: { cookies_enabled: true },
		ajax: { deny_list: ["bam.eu01.nr-data.net"] }
	},
	info: {
		beacon: "bam.eu01.nr-data.net",
		errorBeacon: "bam.eu01.nr-data.net",
		licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
		applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
		sa: 1
	},
	loader_config: {
		accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
		trustKey: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
		agentID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
		licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
		applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID
	}
};

const isNewRelicConfig = () => {
	if (!nrConfigurations.info.licenseKey || !nrConfigurations.info.applicationID || !nrConfigurations.loader_config.accountID) {
		return false;
	}

	return nrConfigurations && nrConfigurations.init && nrConfigurations.info && nrConfigurations.loader_config;
};

export { isNewRelicConfig, nrConfigurations };
